import { useState } from "react";
import { chip } from "@/components/site/OrderSpecFields";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const input = "mt-2 w-full rounded-xl border border-white/10 bg-white/5 px-3.5 py-2.5 text-sm text-white placeholder:text-zinc-500 outline-none focus:border-white/40";

// Grupo de botões de escolha única; com `other`, aparece "Outra" para digitar um valor fora da lista.
export const ChipGroup = ({ label, options, value, onChange, testid, other = false, otherLabel = "Outra", placeholder = "Digite" }) => {
  const [typing, setTyping] = useState(other && !!value && !options.includes(value));
  const pick = (o) => {
    setTyping(false);
    onChange(o);
  };
  return (
    <div data-testid={testid}>
      <span className="mb-1.5 block text-xs text-zinc-400">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button type="button" key={o} data-testid={`${testid}-${slug(o)}`} aria-pressed={!typing && value === o} onClick={() => pick(o)} className={chip(!typing && value === o)}>{o}</button>
        ))}
        {other && (
          <button type="button" data-testid={`${testid}-other`} aria-pressed={typing} onClick={() => { setTyping(true); onChange(""); }} className={chip(typing)}>{otherLabel}</button>
        )}
      </div>
      {typing && <input data-testid={`${testid}-other-input`} autoFocus value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={input} />}
    </div>
  );
};
